import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid
} from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { getDateNow } from '../../../utils/convert';

import moment from 'moment';
import 'moment/locale/es';
import React, { useEffect, useState } from 'react';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { TextInput } from '../../../components/textInput/TextInput';
import { TimeInput } from '../../../components/timeInput/TimeInput';
import './frecuenciaDetalleModal.scss';

const locale = "es-ES";

export const FrecuenciaDetalleModal = ({ open, onClose, dataFormModel, setDataFormModel, isNew, editRow }) => {

    const initialFrecuencia = {
        idFrecuenciaDistribuidor: 0,
        idFrecuenciaDistribuidorDetalle: 0,
        metodoCobroBulto: false,
        metodoCobroKm: false,
        metodoCobroKilo: false,
        demoraHoraDestino: 0,
        horaSalida: getDateNow(true),
        listaFrecuenciaDistribuidorDetalleDias: [],
    };

    const editFrecuencia = {
        idFrecuenciaDistribuidor: editRow?.idFrecuenciaDistribuidor,
        idFrecuenciaDistribuidorDetalle: editRow?.idFrecuenciaDistribuidorDetalle,
        metodoCobroBulto: editRow?.metodoCobroBulto,
        metodoCobroKm: editRow?.metodoCobroKm,
        metodoCobroKilo: editRow?.metodoCobroKilo,
        demoraHoraDestino: editRow?.demoraHoraDestino,
        horaSalida: moment(editRow?.horaSalida, 'HH:mm:ss'),
        listaFrecuenciaDistribuidorDetalleDias: editRow?.listaFrecuenciaDistribuidorDetalleDias,
    };

    const [dataFrecuencia, setDataFrecuencia] = useState(isNew ? initialFrecuencia : editFrecuencia);
    const [dias, setDias] = useState([]);

    useEffect(() => {
        setDias(loadDias);

        if (!isNew) {
            const diasSelected = editRow?.listaFrecuenciaDistribuidorDetalleDias?.map((obj) => {
                return obj?.numeroDia || obj;
            });

            setDataFrecuencia({
                ...editFrecuencia,
                listaFrecuenciaDistribuidorDetalleDias: diasSelected
            })
        }
    }, [editRow])

    const loadDias = () => {
        let start = 1;
        let end = (dataFormModel.idFrecuenciaModoDespacho == 1) ? 7 : 31;

        let dias = Array(end - start + 1).fill().map(() => {
            let id = start++;
            return {
                id: id,
                displayName: id
            }
        });

        return dias;
    }

    const handleChange = (e) => {
        const { value, name } = e.target;

        setDataFrecuencia(previousData => ({
            ...previousData,
            [name]: value
        }));
    }

    const handleToggle = (e) => {
        const { checked, name } = e.target;
        setDataFrecuencia(previousData => ({
            ...previousData,
            [name]: checked
        }));
    }

    const handleChangeHora = (value) => {
        setDataFrecuencia(previousData => ({
            ...previousData,
            horaSalida: value
        }));
    }

    const handleChangeDias = (e) => {
        const { value } = e.target;

        setDataFrecuencia(previousData => ({
            ...previousData,
            listaFrecuenciaDistribuidorDetalleDias: value
        }));
    }

    const handleAdd = () => {
        if (isValidItem()) {
            addFrecuencia();
            onClose();
            cleanItem();
        }
    }

    const handleEdit = (row) => {
        if (isValidItem()) {
            editarFrecuencia();
            onClose();
            cleanItem();
        }
    }

    const handleCancelar = () => {
        cleanItem();
        onClose()
    }

    const addFrecuencia = () => {
        const id = (-1) * dataFormModel?.rowsFrecuencias?.length - 1;
        let listado = dataFrecuencia?.listaFrecuenciaDistribuidorDetalleDias.map((item) => {
            return {
                idFrecuenciaDistribuidorDetalleDia: 0,
                idFrecuenciaDistribuidorDetalle: id,
                numeroDia: item
            }
        })

        let objeto = {
            idFrecuenciaDistribuidorDetalle: id,
            idFrecuenciaDistribuidor: 0,
            horaSalida: moment(dataFrecuencia?.horaSalida).format("HH:mm"),
            demoraHoraDestino: parseInt(dataFrecuencia?.demoraHoraDestino),
            metodoCobroBulto: dataFrecuencia?.metodoCobroBulto,
            metodoCobroKilo: dataFrecuencia?.metodoCobroKilo,
            metodoCobroKm: dataFrecuencia?.metodoCobroKm,
            listaFrecuenciaDistribuidorDetalleDias: listado
        };

        setDataFormModel(previousData => ({
            ...previousData,
            rowsFrecuencias: [...previousData.rowsFrecuencias, objeto]
        }));
    }

    const editarFrecuencia = () => {
        let listado = dataFrecuencia?.listaFrecuenciaDistribuidorDetalleDias?.map((item) => {
            let frecuenciaDetalle = dataFormModel?.rowsFrecuencias?.find(x => x.idFrecuenciaDistribuidorDetalle == dataFrecuencia.idFrecuenciaDistribuidorDetalle)

            let diaAsignado = frecuenciaDetalle?.listaFrecuenciaDistribuidorDetalleDias?.find(x => x.numeroDia == item)

            return {
                idFrecuenciaDistribuidorDetalleDia: (diaAsignado) ? diaAsignado.idFrecuenciaDistribuidorDetalleDia : 0,
                idFrecuenciaDistribuidorDetalle: (diaAsignado) ? diaAsignado.idFrecuenciaDistribuidorDetalle : 0,
                numeroDia: item
            }
        })

        let objeto = {
            idFrecuenciaDistribuidorDetalle: dataFrecuencia?.idFrecuenciaDistribuidorDetalle,
            idFrecuenciaDistribuidor: dataFrecuencia?.idFrecuenciaDistribuidor,
            horaSalida: moment(dataFrecuencia?.horaSalida).format("HH:mm"),
            demoraHoraDestino: parseInt(dataFrecuencia?.demoraHoraDestino),
            metodoCobroBulto: dataFrecuencia?.metodoCobroBulto,
            metodoCobroKilo: dataFrecuencia?.metodoCobroKilo,
            metodoCobroKm: dataFrecuencia?.metodoCobroKm,
            listaFrecuenciaDistribuidorDetalleDias: listado
        };

        setDataFormModel(previousData => ({
            ...previousData,
            rowsFrecuencias: [...previousData.rowsFrecuencias.filter(x => x.idFrecuenciaDistribuidorDetalle !== dataFrecuencia.idFrecuenciaDistribuidorDetalle), objeto]
        }));

    }

    const cleanItem = () => {
        setDataFrecuencia(initialFrecuencia);
    }

    const isValidItem = () => {

        if (dataFrecuencia?.listaFrecuenciaDistribuidorDetalleDias?.length <= 0) {
            toast.error('Debe ingresar al menos un Día.');
            return false;
        }
        if (dataFrecuencia.horaSalida.length <= 0) {
            toast.error('Debe ingresar el campo Hora de Despacho.');
            return false;
        }
        if (dataFrecuencia.demoraHoraDestino < 0) {
            toast.error('Debe ingresar el campo Demora.');
            return false;
        }
        if (!dataFrecuencia.metodoCobroBulto && !dataFrecuencia.metodoCobroKm && !dataFrecuencia.metodoCobroKilo) {
            toast.error('Debe ingresar al menos una Modalidad.');
            return false;
        }

        return true;
    }

    return (
        <>
            <CustomDialog
                maxWidth="md"
                fullWidth
                open={open}
                onClose={onClose}
                title={'Frecuencia'}
                onCancel={handleCancelar}
                onAccept={() => isNew ? handleAdd() : handleEdit(editRow)}
                acceptText={isNew ? 'Agregar' : 'Guardar'}
            >
                <div className=''>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        columns={{
                            xs: 2,
                            md: 3
                        }}
                        spacing={1}
                        marginTop={1}
                    >
                        <Grid size={{ xs: 1 }}>
                            <SelectInput
                                multiple={true}
                                options={dias}
                                label='Dias'
                                onChange={handleChangeDias}
                                value={dataFrecuencia.listaFrecuenciaDistribuidorDetalleDias}
                                name='numeroDia'
                                margin={'normal'}
                            />
                        </Grid>
                        <Grid size={{ xs: 1 }}>
                            <TimeInput
                                label="Hora Despacho"
                                name='horaSalida'
                                value={dataFrecuencia?.horaSalida}
                                onChange={handleChangeHora}
                            />
                        </Grid>
                        <Grid size={{ xs: 1 }}>
                            <TextInput
                                label='Demora Hs.'
                                placeholder='Demora'
                                type='number'
                                name='demoraHoraDestino'
                                value={dataFrecuencia?.demoraHoraDestino}
                                onChange={handleChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        justifyContent={'space-between'}
                        columns={{
                            xs: 2,
                            md: 3
                        }}
                        marginTop={1}
                    >
                        <Grid size={{ xs: 3 }}>
                            <div className='frecuencia-detalle-modal'>
                                <FormControl component="fieldset">
                                    <div className='span-display'>
                                        <h4>Modalidad</h4>
                                        <FormGroup aria-label="position" row>
                                            <FormControlLabel
                                                value={dataFrecuencia?.metodoCobroKm}
                                                name="metodoCobroKm"
                                                control={<Checkbox checked={dataFrecuencia?.metodoCobroKm} />}
                                                label="Km"
                                                labelPlacement="Km"
                                                onChange={handleToggle}
                                                className='span-margin'
                                            />
                                            <FormControlLabel
                                                value={dataFrecuencia?.metodoCobroBulto}
                                                name="metodoCobroBulto"
                                                control={<Checkbox checked={dataFrecuencia?.metodoCobroBulto} />}
                                                label="Bulto"
                                                labelPlacement="Bulto"
                                                onChange={handleToggle}
                                            />
                                            <FormControlLabel
                                                value={dataFrecuencia?.metodoCobroKilo}
                                                name="metodoCobroKilo"
                                                control={<Checkbox checked={dataFrecuencia?.metodoCobroKilo} />}
                                                label="Kilo"
                                                labelPlacement="Kilo"
                                                onChange={handleToggle}
                                            />
                                        </FormGroup>
                                    </div>
                                </FormControl>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </CustomDialog>
        </>
    )
}
